import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckAlt, faInfoCircle, faDownload } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { HR_NAV } from './nav';

const Payroll: React.FC = () => {
    const { api } = useInternalApi();
    const [people, setPeople] = useState<any[]>([]);
    const [period, setPeriod] = useState('');
    const [headcount, setHeadcount] = useState(0);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Payroll Interface - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('hr-api/payroll/').then(r => {
            if (r.data?.status === 'success') {
                setPeople(r.data.data.people || []);
                setPeriod(r.data.data.period || '');
                setHeadcount(r.data.data.headcount || 0);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const exportCsv = () => {
        const header = 'Employee ID,Name,Department,Role,Approved leave days,Unpaid leave days';
        const rows = people.map(p => [p.internal_user_id, p.full_name, p.department, p.role,
            p.approved_leave_days_this_month, p.unpaid_leave_days_this_month].join(','));
        const blob = new Blob([[header, ...rows].join('\n')], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = `payroll-input-${period}.csv`; a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <InternalShell activeDashboard="human_resources" subNav={HR_NAV}>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faMoneyCheckAlt} className="me-2 text-primary" />Payroll Interface</h2>
                    <p className="text-muted mb-0">Headcount and leave extract for {period}</p>
                </div>
                {people.length > 0 && (
                    <button className="btn btn-outline-primary" onClick={exportCsv}>
                        <FontAwesomeIcon icon={faDownload} className="me-2" />Export CSV
                    </button>
                )}
            </div>

            <div className="alert alert-warning small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    <div className="row mb-4">
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Active headcount</div><h4>{headcount}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Period</div><h4>{period}</h4>
                        </div></div></div>
                    </div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white"><strong>Payroll input extract</strong></div>
                        <div className="card-body p-0">
                            {people.length === 0 ? (
                                <div className="text-center py-5 text-muted">No active staff.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Employee</th><th>Department</th><th>Role</th><th>Approved leave (days)</th><th>Unpaid leave (days)</th></tr></thead>
                                    <tbody>
                                        {people.map(p => (
                                            <tr key={p.internal_user_id}>
                                                <td><strong>{p.full_name}</strong><div className="small text-muted">#{p.internal_user_id}</div></td>
                                                <td className="small">{p.department}</td>
                                                <td className="small">{p.role}</td>
                                                <td>{p.approved_leave_days_this_month}</td>
                                                <td className={p.unpaid_leave_days_this_month > 0 ? 'text-warning' : ''}>{p.unpaid_leave_days_this_month}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default Payroll;
